// BNB
export const DEFAULT_INPUT_CURRENCY = 'BNB'
// BUSD
export const DEFAULT_OUTPUT_CURRENCY = '0x28208DE7C6879Ac7365a75EA6727bDA431fd2B07'
